import { Wrench } from "lucide-react";

import { euros } from "@/components/pipeline/utils";

export const STAGE_TONE = { signed: "butter", vt: "butter", install: "butter", cee: "tomato", paid: "pine", done: "pine" };

export const Amount = ({ value, testid }) => <span data-testid={testid}>{euros(value) || "—"}</span>;

export const SavBadge = ({ sav, testid }) => {
  if (!sav?.status) return null;
  const open = sav.status === "open";
  return <span className={`pl-badge cl-sav ${open ? "danger" : "ok"}`} title={sav.excerpt || sav.reason} data-testid={testid}><Wrench size={11} /> {open ? "SAV ouvert" : "SAV résolu"}</span>;
};

export const place = (c) => [c.zipcode, c.city].filter(Boolean).join(" ");
